import type { IStyleParam } from '@wix/tpa-settings';
import {
  createStylesParams,
  StyleParamType,
  wixColorParam,
  wixFontParam,
} from '@wix/tpa-settings';

const defaultBodyMFont: NonNullable<
  IStyleParam<StyleParamType.Font>['getDefaultValue']
> = (params) =>
  wixFontParam('Body-M', {
    htmlTag: 'p',
    size: params.isMobile ? 14 : 16,
  })(params);

export type DispatchInfoStylesParams = {
  dispatchTextFont: StyleParamType.Font;
  dispatchTextColor: StyleParamType.Color;
  dispatchLinkFont: StyleParamType.Font;
  dispatchLinkColor: StyleParamType.Color;
  dispatchShowIcon: StyleParamType.Boolean;
  dispatchIconSize: StyleParamType.Number;
  dispatchIconColor: StyleParamType.Color;
};

export const dispatchInfoStylesParams =
  createStylesParams<DispatchInfoStylesParams>({
    dispatchTextFont: {
      type: StyleParamType.Font,
      getDefaultValue: defaultBodyMFont,
    },
    dispatchTextColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
    dispatchLinkFont: {
      type: StyleParamType.Font,
      getDefaultValue: defaultBodyMFont,
    },
    dispatchLinkColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-8', 1),
    },
    dispatchShowIcon: {
      type: StyleParamType.Boolean,
      getDefaultValue: () => true,
    },
    dispatchIconSize: {
      type: StyleParamType.Number,
      getDefaultValue: ({ isMobile }) => isMobile ? 16 : 24,
    },
    dispatchIconColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 1),
    },
  });
